
export default function DemoSection() {
  return (
    <section className="bg-[#FFD93D] py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Take a look at Bumblebee
          </h2>
        </div>

        <div className="bg-white rounded-lg shadow-2xl overflow-hidden">
          <div className="aspect-video">
            <iframe 
              src="https://www.loom.com/embed/ea90854d6bac49a4903dfa17eca45894"
              frameBorder="0"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-br from-yellow-50 to-white rounded-2xl shadow-xl p-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Schedule a Demo
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Share datasets and scripts, empower your data analyst team to explore and share findings with the entire company, clean your data automatically on a schedule.
          </p>
          <a 
            href="https://optimusdata.typeform.com/to/AdJj1n" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#FFD93D] hover:bg-[#FFB627] text-gray-900 font-semibold px-8 py-3 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Schedule
          </a>
        </div>
      </div>
    </section>
  );
}
